import { InjectionToken, Provider } from '@angular/core';
import { AddressBookApiService } from '../address-book-api.service';
import { AddressBookRepository } from '../address-book.repository';

export const HTTP_ADDRESS_BOOK_SERVICE = new InjectionToken<AddressBookRepository>('AddressBookRepository');

export const ADDRESS_BOOK_API_PROVIDER: Provider = {
    provide: HTTP_ADDRESS_BOOK_SERVICE,
    useClass: AddressBookApiService,
};
